import { Card, Col, Row,Button } from "reactstrap";

import React from "react";
import Chart from 'chart.js/auto';
import Service from "src/api/Service";
import colorPalette from "src/assets/js/colorPalette";

class BarChartKPI extends React.Component{

    constructor(props) {
        super();
        this.state = {
          isFetching: false,
           module:[],
           prod:0,
           loc:0,
           showLegends:false,
    
          }
       
          this.productUp = this.productUp.bind(this);   
          this.Legend = this.Legend.bind(this);

      }
    
    
    chartRef1 = React.createRef();
      
    
    
      async getAbsenceChart(){
        var url = "datamonitor/tabPABar?keyname="+this.props.prams.keyname;
        console.log(url);
         await Service.get(url,(status,data)=>{
        
         if(status==200){
           this.CreateChart(data['data']);
        }
         
    
       });
      }
        
      componentDidMount() {
        this.getAbsenceChart();
           
      }
       myChart="";
      CreateChart(data){
      
        const myChartRef1 = this.chartRef1.current.getContext("2d");
          
        var data_dc = [];
          var data_dp = [];
          var data_da = [];
      
          // data arrays For line chart
          var data_line_x_labels = []; // Labels for the x-axis
      
          // data arrays For bar chart
          var data_bar_x_labels = []; // Labels f
      
            data.forEach(element => {
            
             data_dc.push({
                  "x": element.locations,
                  "y": element.planned_qty,
              });
              data_dp.push({
                  "x": element.locations,
                  "y": element.actual_qty,
              });
      
              data_bar_x_labels.push(element.products+" ( "+element.locations+" ) ");
             
          });
      
      
              
                  // 2nd Bar Graph
      
      
          function mapExtractYAxisData(itm) {
              return itm.y;
          }
             var bar_data = {
              labels: data_bar_x_labels,
              datasets: [{
                      label: 'Planned Volume',
                      data: data_dc.map(mapExtractYAxisData),
                      borderColor: colorPalette[0]['chartColor'][0],
                      backgroundColor: colorPalette[0]['chartColor'][0],
                      borderWidth: 1
                  },
                  {
                      label: 'Produced Volume',
                      data: data_dp.map(mapExtractYAxisData),
                      borderColor: colorPalette[0]['chartColor'][1],
                      backgroundColor:colorPalette[0]['chartColor'][1],
                      borderWidth: 1
                  }
                  
              ]
          };
      
         this.myChart= new Chart(myChartRef1, {
              type: 'bar',
              data: bar_data,

              options: {
                  responsive: true,
                  barValueSpacing: 20,
                  scales: {
                    x: {
                      ticks: {
                        // color: 'red',
                        font: {
                            size: 10
                          }
                      },
                    },
                  },
                  plugins:{
                    legend: {
                        display: this.state.showLegends,
                        position: 'bottom',       
                        align:'left',
                        fullSize:true,
                        labels:{
                          boxWidth:10,
                          textAlign:'left',
                          font: {
                            size: 10
                          }
                        }
                      },
                          tooltips: {
                              callbacks: {
                                  title: function () {},
                                  label: function (tooltipItem, data) {
                                    console.log("data------------------");
                                    console.log(data);
                                    //   if (tooltipItem.datasetIndex === 0) {
                                    //       return tooltipItem.yLabel + " Day Count in " + tooltipItem.xLabel;
                                    //   } else if (tooltipItem.datasetIndex === 1) {
                                    //       return tooltipItem.yLabel + " Avg. Days Worked in " + tooltipItem.xLabel;
                                    //   } else if (tooltipItem.datasetIndex === 2) {
                                    //       return tooltipItem.yLabel + " Avg. Days Absent in " + tooltipItem.xLabel;
                                    //   }
                                  }
                              }
                          }
                       }
                      }
                });
                
      }



      async productUp(filterData){
       
        var obj ={};
         obj['data']=filterData;
         obj['keyname']=this.props.prams.keyname;
    
        var url = "datamonitor/tabPABar/getFilterData";
        await Service.post(url,obj,(status,data)=>{     
          if(status==200){ 
          
           this.myChart.destroy();
            this.CreateChart(data);
         }
          
     
        });

      }
     
    Legend(){
        console.log("Click");
        
        this.setState({
            showLegends:!this.state.showLegends
        })
        this.myChart.destroy();
        this.getAbsenceChart();
      }   
    
     render(){

  if(this.props.filterData.length == undefined ){
    this.productUp(this.props.filterData);
  }
//   this.props.prams.component
     return (
            <>
                <div className='row'>
                    <div className='col-lg-7'>
                    <div className='componentNameC'>{this.props.prams.component}</div>
                    </div>
                    <div className='col-lg-5'>
                    <div className="form-check component_legend" >
                    <span className="bigcheck">
                        <label className="bigcheck">
                            <input type="checkbox" className="bigcheck" onChange={this.Legend}  name="Legend" value="yes"/>
                            <span className="bigcheck-target"></span>
                            &nbsp; Legend
                        </label>
                    </span>
                </div>
                    </div>
                    </div>
             <div className="p-2">              
               <div className="row">             
    
                <div className='col-lg-12'>
                
                  <canvas  id="myChart1" ref={this.chartRef1} />
               
                </div>
    
               </div>
            </div>
            </>
    
      );
     }
    };
    

export default BarChartKPI;